module.exports = __webpack_public_path__ + "static/media/renata.481fa42e.jpg";